import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {Menu} from '../../meta.menu';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsModalService} from 'ngx-bootstrap/modal';
import {faArrowLeft, faArrowRight, faPlus, faTrash, faEdit} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'lib-menu-header-view',
    templateUrl: './menu-header-view.component.html',
    styleUrls: ['./menu-header-view.component.css'],
})
export class MenuHeaderViewComponent implements OnInit {

  @Input()
  public menu: Menu | null;

  @Output()
  menuDeleted = new EventEmitter();

  @Output()
  menuAdded = new EventEmitter();

  @Output()
  menuMoved = new EventEmitter<number>();

  public mouseActive = false;

  menuForm: FormGroup;

  faArrowLeft = faArrowLeft;
  faArrowRight = faArrowRight;
  faPlus = faPlus;
  faTrash = faTrash;
  faEdit = faEdit;

  constructor(
    protected readonly fb: FormBuilder,
    protected readonly modalService: BsModalService) {
    this.menuForm = this.fb.group({
      label: [''],
    });
  }

  ngOnInit(): void {
  }

  @HostListener('mouseenter')
  mouseenter() {
    this.mouseActive = true;
  }

  @HostListener('mouseleave')
  mouseleave() {
    this.mouseActive = false;
  }

  onAdd() {
    this.menuAdded.next(null);
  }

  onDelete() {
    this.menuDeleted.next(null);
  }

  onMove(direction: number) {
    this.menuMoved.next(direction);
  }

  onEditMenu(content: any) {
    if(this.menu) {
      this.menuForm.patchValue(this.menu);
      this.modalService.show(content, {ariaLabelledBy: 'modal-basic-title'}).onHide.subscribe((reason) => {
        console.log(`dismissed: ${reason}`);
      });
    }
  }

  onSave(modal: any) {
    modal.hide('Save click')
    if(this.menu) {
      const editedItem = this.menuForm.value;
      this.menu = Object.assign(this.menu, editedItem);
    }
  }
}
